import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { MapPin, Loader2, CheckCircle2, ArrowRight } from "lucide-react";
import { AddressAutocomplete } from "../intake/AddressAutocomplete";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CoverageChecker = () => {
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const trimmed = address.trim();
    if (trimmed.length < 5) {
      toast.error("Please enter your service address (or at least a 5-digit ZIP code).");
      return;
    }
    setBusy(true);
    try {
      await axios.post(`${API}/coverage`, { address: trimmed, email: email.trim(), service: "Business Internet" });
      setDone(true);
      toast.success("Availability request received — our service desk will reply shortly.");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="coverage-checker" className="border border-cyan-400/30 bg-[#05071F] p-8 sm:p-10">
      {done ? (
        <div data-testid="coverage-success" className="flex items-center gap-4">
          <CheckCircle2 className="w-8 h-8 text-cyan-400 shrink-0" />
          <div>
            <p className="font-heading text-lg font-medium text-white">Request received for {address}</p>
            <p className="text-sm text-slate-400 mt-1">Our service desk will email you availability and options at your site.</p>
          </div>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-3">
            <MapPin className="w-6 h-6 text-cyan-400" />
            <h3 className="font-heading text-xl sm:text-2xl font-medium text-white">Is business internet available at your site?</h3>
          </div>
          <p className="mt-2 text-sm text-slate-400">Enter your service address and we'll check fiber, cable, and satellite options across 400+ carriers — a full address gives the most precise results, but a ZIP code works too.</p>
          <form onSubmit={submit} className="mt-6 flex flex-col sm:flex-row gap-3">
            <div className="flex-[1.4]">
              <AddressAutocomplete testid="coverage-address-input" value={address} onChange={setAddress}
                placeholder="Service address — e.g. 1200 Farnam St, Omaha, NE 68102" />
            </div>
            <input data-testid="coverage-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="Business email"
              className="flex-1 bg-[#05071F] border border-white/15 rounded-md px-4 py-2 text-sm text-white placeholder:text-slate-500 focus:outline-none focus:border-cyan-400" />
            <button type="submit" data-testid="coverage-submit-btn" disabled={busy}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-cyan-400 text-[#05071F] font-semibold px-7 py-2.5 rounded-full hover:bg-cyan-300 transition-colors disabled:opacity-60">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <ArrowRight className="w-4 h-4" />} Check Availability
            </button>
          </form>
        </>
      )}
    </div>
  );
};
